import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/redux.hooks';
import {
  getOnboardingSteps,
  resetOnboardingStatus,
  updateOnboardingSteps,
} from '../reducers/onboarding.reducer';
import { useParams } from 'react-router-dom';
import Loading from '../components/loading/Loading';
import { useToast } from '../components/toast/ToastProvider';
import Row from '../components/layout/Row';
import { Text } from '../components/font/Text';
import { OnboardingSteps as Steps } from '../models/onboarding.steps';
import { Divider, Switch } from 'antd';
import Spacer from '../components/layout/Spacer';
import styled from 'styled-components';

const OnboardingSteps = () => {
  const params = useParams();
  const { id: shop_id } = params;
  const dispatch = useAppDispatch();
  const { data, status, updateStatus } = useAppSelector(
    (state) => state.onboardingReducer
  );
  const toast = useToast();
  const [steps, setSteps] = useState<Steps[]>([]);
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    dispatch(getOnboardingSteps(shop_id!));
  }, [dispatch, shop_id]);

  useEffect(() => {
    if (status === 'successful') {
      setSteps(data);
    }
  }, [status]);

  useEffect(() => {
    if (updateStatus == 'successful') {
      toast.show('Successfully updated the onboarding steps');
      setIsModified(false);
      dispatch(resetOnboardingStatus());
    }
    if (updateStatus === 'error') {
      toast.show('Failed to update the onboarding steps', { isError: true });
      dispatch(resetOnboardingStatus());
    }
  }, [dispatch, updateStatus, toast]);

  const handleUpdateOnboardingSteps = () => {
    dispatch(updateOnboardingSteps({ shop_id: shop_id!, data: steps }));
  };

  const renderView = () => {
    if (status === 'loading') {
      return (
        <Row>
          <Loading loadingMessage='Fetching onboarding steps' />
        </Row>
      );
    } else {
      return (
        <CardContainer>
          <s-section heading='Onboarding steps'>
            {steps.map((step) => {
              const checked = step.status === 'COMPLETED';
              return (
                <OnboardingItem key={step.onboarding_key}>
                  <Text>{step.onboarding_key}</Text>
                  <Switch
                    checked={checked}
                    style={{
                      backgroundColor: checked ? '#008060' : '#ccc',
                      alignSelf: 'flex-end',
                    }}
                    onChange={(newChecked) => {
                      setSteps((prevSteps) =>
                        prevSteps.map((s) =>
                          s.onboarding_key === step.onboarding_key
                            ? {
                                ...s,
                                status: newChecked ? 'COMPLETED' : 'PENDING',
                              }
                            : s
                        )
                      );
                      setIsModified(true);
                    }}
                  />
                </OnboardingItem>
              );
            })}
          </s-section>
        </CardContainer>
      );
    }
  };

  return (
    <s-page>
      {renderView()}
      <Spacer />
      <s-button
        onClick={handleUpdateOnboardingSteps}
        disabled={!isModified || updateStatus === 'loading'}
      >
        Update onboaring steps
      </s-button>
    </s-page>
  );
};

export default OnboardingSteps;

const OnboardingItem = styled(Row)`
  padding: 8px;
  justify-content: space-between;
`;

const CardContainer = styled.div`
  width: 64%;
`;
